module.exports = __webpack_public_path__ + "static/img/wangchuangcode.43122e8.png";


//////////////////
// WEBPACK FOOTER
// ./static/wangchuangcode.png
// module id = b792
// module chunks = 1